import FileService from '@/services/FileService'

const createFilesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    files: [],
    filterImage: ''
  },
  actions: {
    getFiles: ({ commit, state }) => {
      FileService.getFiles(state.pageSize, state.page, state.filterImage)
        .then((data) => {
          commit('SET_FILES', { files: data.files })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, state }, page) => {
      state.page = page
      dispatch('getFiles')
    },
    setFilter: ({ dispatch, state }, filter) => {
      state.filterImage = filter
      dispatch('getFiles')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    },
    filterImage: (state) => state.filterImage
  },
  mutations: {
    SET_FILES: (state, { files }) => {
      state.files = files
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createFilesModule
